module.exports = __webpack_public_path__ + "static/media/10R-2-3-2-3-45@3x.670a0f67.png";